import React, { Component } from "react";
import styles from "./trips.module.scss";
import LogisticAlatmTool from "../AlarmTools/LogisticAlatmTool";
import { states } from "../../../reducers/queriesStates";
import { withLogisticTrips } from "../../../shared/containers/containerLogisticTrips";
import { withLogisticTripRoutes } from "../../../shared/containers/containerLogisticTripRoutes";
import { duration } from "@material-ui/core";
import { withLogisticRoutes } from "../../../shared/containers/containerLogisticRoutes";

class TripRouteAlarm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorTitle: null,
    };
  }

  componentDidUpdate(preProps) {
    const { logisticUpdateTripRouteAlarmDataState, errors, onGetLogisticTrip, tripId } = this.props;
    if (logisticUpdateTripRouteAlarmDataState === states.FAILURE && preProps.logisticUpdateTripRouteAlarmDataState === states.REQUEST) {
      const index = errors[0].data.indexOf("\n\r");
      const errorTile = errors[0].data.substring(0, index);
      this.setState({ errorTile });
    }

    if (logisticUpdateTripRouteAlarmDataState === states.READY && preProps.logisticUpdateTripRouteAlarmDataState === states.REQUEST) {
      onGetLogisticTrip({ id: tripId });
    }
  }

  onUpdateAlarm(alarm) {
    const { onUpdateLogisticTripRouteAlarm, route, tripId } = this.props;
    this.setState({ errorTile: null });

    onUpdateLogisticTripRouteAlarm({ routeId: route.id, tripId, AlarmActive: alarm.active, duration: alarm.duration, time: alarm.time });
  }

  onCloseHandler() {
    const { onSetTripRouteAlarmView } = this.props;

    onSetTripRouteAlarmView(false, null);
  }

  render() {
    const { route, logisticUpdateTripRouteAlarmDataState } = this.props;
    const { errorTile } = this.state;

    return (
      <div className={styles.tripControlPointAlarmContainer}>
        <LogisticAlatmTool
          key={route.id}
          title={`Маршрут "${route.title}"`}
          alarm={JSON.parse(JSON.stringify(route.alarm))}
          withDays={true}
          onUpdateAlarm={this.onUpdateAlarm.bind(this)}
          errorTile={errorTile}
          isRequest={logisticUpdateTripRouteAlarmDataState === states.REQUEST}
          onClose={this.onCloseHandler.bind(this)}
        />
      </div>
    );
  }
}

export default withLogisticTrips(withLogisticRoutes(withLogisticTripRoutes(React.memo(TripRouteAlarm))));
